<script setup>
import menusDefault from "@/datas/menus"
import menusV2 from "@/datas/menus_v2"
import { useSnackBar } from '@/utils/stores/snackbar'
import { computed } from "vue"

import { getProjectId } from "@/utils/cdms"

definePage({
  meta: {
    layout: 'blank',
    action: 'read',
    subject: 'permissions',
  },
})

const { data: project } = await useApi(createUrl(`/projects/${getProjectId()}`, {
  query: {
  },
}))

// 항상 v2 메뉴 구성을 사용하도록 고정
const menus = computed(() => menusV2)


const snackbarStore = useSnackBar()

const roleData = ref([])

const r = ref({ name: "" })

const p = reactive({
})

const {  data,  error, execute: fetchDatas } = await useApi(createUrl('/management/roles/all', {
  query: {
  },
}))

if (error.value) {
  console.log(error.value)
} else {
  roleData.value = data.value.splice(1)
}

// role 가져오기

const getPermissions = async role => {
  r.value = role

  const { data, error } = await useApi(createUrl('/management/permissions/by-role', {
    query: {
      role: role.name,
    },
  }))

  if (error.value) {
    console.log(error.value)
  } else {
    Object.keys(p).forEach(key => {
      delete p[key]
    })

    Object.assign(p, vuexyPermissionToObject(data.value) )
  }
}

const vuexyPermissionToObject = permissions => {
  let list = {}
  permissions.forEach(permission => {
    if(list[permission.subject]) {
      list[permission.subject].push(permission.action)
    } else {
      list[permission.subject] = [permission.action]
    }
  })

  return list
}

const save = async () => {
  let permissions = []
  Object.keys(p).forEach(subject => {
    p[subject].forEach(action => {
      permissions.push(subject + "_" + action)
    })

  })

  const store = await $api(`/management/permissions/sync-role`, { method: 'POST',
    body: {
      role: r.value.name,
      permissions,
    } })

  snackbarStore.showSnackBar("Successfully Saved!")
}
</script>

<template>
  <VRow>
    <VCol cols="4">
      <VCard>
        <VCardTitle>
          Roles
        </VCardTitle>
        <VCardText>
          <VList
            nav
            :lines="false"
          >
            <VListItem
              v-for="item in roleData"
              :key="item.name"
              :value="item.name"
              @click="getPermissions(item)"
            >
              <template #prepend>
                <VIcon icon="tabler-point" />
              </template>

              <VListItemTitle>
                {{ item.name }}
              </VListItemTitle>
            </VListItem>
          </VList>
        </VCardText>
      </VCard>
    </VCol>
    <VCol cols="8">
      <h3> {{ r?.name }} </h3>
      <VExpansionPanels variant="accordion">
        <VExpansionPanel
          v-for="(menu, i) in menus"
          :key="i"
        >
          <VExpansionPanelTitle>
            <template
              v-if="!menu.subs"
              #actions
            />
            <VRow>
              <VCol cols="8">
                {{ menu.title }}
              </VCol>
              <VCol cols="4">
                <AppSelect
                  v-if="!menu.subs"
                  v-model="p[menu.permission]"
                  :items="menu.items"
                  placeholder="접근불가"
                  chips
                  multiple
                  closable-chips
                />
              </VCol>
            </VRow>
          </VExpansionPanelTitle>
          <VExpansionPanelText v-if="menu.subs">
            <VRow
              v-for="(sub, j) in menu.subs"
              :key="j"
            >
              <VDivider class="my-2" />
              <VCol
                cols="8"
                class="pl-8"
                style="font-size: 15px;"
              >
                {{ sub.title }}
              </VCol>
              <VCol cols="4">
                <AppSelect
                  v-model="p[sub.permission]"
                  :items="sub.items"
                  placeholder="접근불가"
                  chips
                  multiple
                  closable-chips
                />
              </VCol>
            </VRow>
          </VExpansionPanelText>
        </VExpansionPanel>
      </VExpansionPanels>
    </VCol>
  </VRow>
  <VCol
    cols="12"
    class="d-flex justify-end"
  >
    <VBtn @click="save">
      Save
    </VBtn>
  </VCol>
</template>
